import { render, staticRenderFns } from "./notice-receiver-options.vue?vue&type=template&id=df062694&scoped=true&"
import script from "./notice-receiver-options.vue?vue&type=script&lang=js&"
export * from "./notice-receiver-options.vue?vue&type=script&lang=js&"
import style0 from "./notice-receiver-options.vue?vue&type=style&index=0&id=df062694&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df062694",
  null
  
)

export default component.exports